//TBD: fix behavior for model update and reuse for address
var InputFieldView = (function (BaseView) {
    return BaseView.extend({

        errorClassName: 'form-row__error',

        events: {
            // warn: element off keypress and paste on model update
            'keyup': 'change',
            'change': 'change'
        },

        initialize: function (opts) {
            this.listenTo(this.model, 'change', _.bind(this._setupInput, this));
            this.listenTo(this.model, 'change:isValid', _.bind(this._isValidChanged, this));
            this.listenTo(this.model, 'change:Value', _.bind(this._updateValue, this));            
            this.listenTo(this.model, 'remove', _.bind(this.remove, this));

            this.errorClassName = this.errorClassName || opts.errorClassName;

            this.$el = opts.el; // all elements in the mockup

            this._setupInput();
            this._update();
        },

        change: function (e) {
            this._setValue(e.currentTarget.value);
        },

        _setupInput: function () {
            this.$el.attr('type', this.model.get('Type'));
            this.$el.attr('name', this.model.get('Name'));
            this.$el.data('mask', this.model.get('DataType'));

            this.$el.off('keypress,paste');//TBD: hot fix for model change
            this.$el.keyFilter(this.model.get('MaxLength'), this.model.get('Regexp'));
        },

        _setValue: function (value) {
            this.model.setValue(value, { silent: true });
            this.model.setChangedByUser();
        },

        _update: function () {
            this._isValidChanged();
            this._updateValue();
        },

        _isValidChanged: function () {
            var isInvalid = this.model.get('isValid') != null && !this.model.get('isValid');
            this.$el.toggleClass(this.errorClassName, isInvalid);
        },

        _updateValue: function () {
            this.$el.val(this.model.get('Value'));
        }
    });
})(BaseView);